import { React } from 'react';

import styles from "../../../styles/chartLog.module.css";
/* ------------------------------------------------------------------------- */

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';


ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const ChartLogs = ({options, data}) => {

  return (
      <div className={styles.chart}>
        <Bar options={options} data={data} />
      </div>
  )
}


export default ChartLogs;